import { render, staticRenderFns } from "./ProductInventory.vue?vue&type=template&id=47ba8909&scoped=true"
import script from "./ProductInventory.vue?vue&type=script&lang=ts"
export * from "./ProductInventory.vue?vue&type=script&lang=ts"
import style0 from "./ProductInventory.vue?vue&type=style&index=0&id=47ba8909&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47ba8909",
  null
  
)

export default component.exports